function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#666",
  fillRule: "evenodd",
  d: "M13.91 12l5.768-5.769 1.19-1.19a.45.45 0 000-.636l-1.273-1.273a.45.45 0 00-.636 0L12 10.091 5.041 3.13a.45.45 0 00-.636 0L3.132 4.406a.449.449 0 000 .636L10.09 12l-6.96 6.959a.45.45 0 000 .636l1.274 1.273a.45.45 0 00.636 0L12 13.909l5.769 5.77 1.19 1.189a.45.45 0 00.636 0l1.273-1.273a.45.45 0 000-.636L13.909 12z"
});

function SvgModalCloseinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgModalCloseinline;